/**
 * Real PDF export via jsPDF (no server round-trip).
 * pdfBlob(rows, fields, title) -> Blob (application/pdf)
 *   rows:   array of objects
 *   fields: [[headerLabel, row => value], ...]
 */
import { jsPDF } from "jspdf";

export function pdfBlob(rows, fields, title = "RestoYaar") {
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();

  const colW = pageW / fields.length;
  const left = 24;
  let y = 40;

  const header = () => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text(title, left, y);
    y += 16;
    doc.setFontSize(8);
    fields.forEach(([label], i) => {
      doc.setFillColor(235, 237, 240);
      doc.rect(left + i * colW, y, colW, 14, "F");
      doc.text(String(label), left + i * colW + 3, y + 10);
    });
    y += 14;
    doc.setFont("helvetica", "normal");
  };

  header();
  rows.forEach(r => {
    if (y > pageH - 28) {
      doc.addPage();
      y = 40;
      header();
    }
    doc.setFontSize(7.5);
    const tallest = fields.reduce((max, [, get], i) => {
      const lines = doc.splitTextToSize(String(get(r) ?? ""), colW - 6);
      doc.text(lines, left + i * colW + 3, y + 9);
      return Math.max(max, lines.length);
    }, 1);
    doc.setDrawColor(210);
    doc.line(left, y + 9 + tallest * 8, pageW - left, y + 9 + tallest * 8);
    y += tallest * 8 + 4;
  });

  return doc.output("blob");
}
